import styles from '../../maintenancerequestdetails.module.css';
import { useEffect, useState } from 'react';
import dayjs from "dayjs";


const HistoryTab = ({ histories }) => {
    const [historyList, setHistoryList] = useState([]);

    useEffect(() => {
        if (histories) {
            setHistoryList(histories);
        }
    }, [histories]);

    return (<>
        {historyList?.map(item => {
            return <div className={`${styles.BorderDivSumm}`} key={item?.id}>
                <div className={`${styles.HistoryTitle}`}>
                    <img src="/static/img/RollCheck.svg" alt="" />
                    <p className={`${styles.HistoryTitleCon}`}>{item.title} <span>{dayjs(item.created_at).format("L")}</span></p>
                </div>
                <div className={`${styles.BorderDivSummHis}`}>
                    <p className={`${styles.SummCommBodyText}`} dangerouslySetInnerHTML={{ __html: item.description }}></p>
                </div>
            </div>
        })}
        {historyList.length === 0 && <div className={`${styles.NoDataMainWithBU} ${styles.WOBS}`}>
            <div>
            <div className={`${styles.NoDataIMGWithBU}`}><img src="/static/img/no-history.png" alt="" /></div>
            <p className={`${styles.NoDataTextWithBU}`}>History List is Empty</p>
            <p className={`${styles.NoDataTextSubWithBU}`}>No record has been submitted yet.</p>
            {/* <button className={`${styles.AddLeaseBUWithBU}`}><Plus /> Add New</button> */}
            </div>
        </div>}
    </>);
}

export default HistoryTab;